import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {TeardownSsoForInstance as TeardownSsoForInstanceMutation} from 'nutshell-graphql-types';

import TEARDOWN_SSO_FOR_INSTANCE from '../mutations/teardown-sso-for-instance.graphql';

export const useTeardownSsoForInstance = (): {
    teardownSsoForInstance: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [teardownSsoForInstance, {loading, error}] = useMutation<
        TeardownSsoForInstanceMutation,
        Record<any, any>
    >(TEARDOWN_SSO_FOR_INSTANCE);

    return {
        teardownSsoForInstance: () => teardownSsoForInstance(),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
